import { render, staticRenderFns } from "./AuthShowcase.vue?vue&type=template&id=563d375b&scoped=true&"
import script from "./AuthShowcase.vue?vue&type=script&lang=js&"
export * from "./AuthShowcase.vue?vue&type=script&lang=js&"
import style0 from "./AuthShowcase.vue?vue&type=style&index=0&id=563d375b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d375b",
  null
  
)

export default component.exports